<template>
  <aside :class="['main-sidebar', 'col-12', 'col-md-3', 'col-lg-2', 'px-0', sidebarVisible ? 'open' : '']">
    <div class="main-navbar">
      <nav class="navbar align-items-stretch navbar-light bg-white flex-md-nowrap border-bottom p-0">
        <d-link class="navbar-brand w-100 mr-0" style="line-height: 25px;">
          <div class="d-table m-auto">
            <img id="main-logo" class="d-inline-block align-top mr-1" style="" src="/img/cp_logo_text.png"
                 alt="Campost Payment">
            <span v-if="!hideLogoText" class="d-none d-md-inline ml-1">Campost Payment Admin</span>
          </div>
        </d-link>
        <a class="toggle-sidebar d-sm-inline d-md-none d-lg-none" @click="handleToggleSidebar()">
          <i class="material-icons">&#xE5C4;</i>
        </a>
      </nav>
    </div>

    <!--<form action="#" class="main-sidebar__search w-100 border-right d-sm-flex d-md-none d-lg-none">-->
    <!--<div class="input-group input-group-seamless ml-3">-->
    <!--<div class="input-group-prepend">-->
    <!--<div class="input-group-text">-->
    <!--<i class="fas fa-search"></i>-->
    <!--</div>-->
    <!--</div>-->
    <!--<input class="navbar-search form-control" type="text" placeholder="Search for something..." aria-label="Search">-->
    <!--</div>-->
    <!--</form>-->

    <div class="nav-wrapper">
      <d-nav class="flex-column">
        <li v-for="(item, navItemIdx) in items" :key="navItemIdx" class="nav-item dropdown">
          <template v-if="auth.hasRole(item.roles)">
            <d-link :class="['nav-link', item.items && item.items.length ? 'dropdown-toggle' : '']" :to="item.to"
                    v-d-toggle="`snc-${navItemIdx}`">
              <div class="item-icon-wrapper" v-if="item.htmlBefore" v-html="item.htmlBefore"/>
              <span v-if="item.title">{{ item.title }}</span>
              <div class="item-icon-wrapper" v-if="item.htmlAfter" v-html="item.htmlAfter"/>
            </d-link>
            <d-collapse v-if="item.items && item.items.length" :id="`snc-${navItemIdx}`"
                        class="dropdown-menu dropdown-menu-small" accordion="sidebar-items-accordion">
              <d-dropdown-item v-for="(subItem, subItemIdx) in item.items" :key="subItemIdx" :href="subItem.href"
                               :to="subItem.to">
                {{ subItem.title }}
              </d-dropdown-item>
            </d-collapse>
          </template>
        </li>
        <!--        <li class="mt-3 pl-3">-->
        <!--          <d-form-checkbox v-model="production" inline toggle>{{env}}</d-form-checkbox>-->
        <!--        </li>-->
      </d-nav>
    </div>
  </aside>
</template>

<script>
import EnvMixin from "@/mixins/EnvMixin"

export default {
  name: "main-sidebar",
  props: {
    /**
     * Whether to hide the logo text, or not.
     */
    hideLogoText: {
      type: Boolean,
      default: false,
    },
    /**
     * The menu items.
     */
    items: {
      type: Array,
      required: true,
    },
  },
  mixins: [EnvMixin],
  data() {
    return {
      sidebarVisible: false,
    }
  },
  created() {
    this.$eventHub.$on("toggle-sidebar", this.handleToggleSidebar)
  },
  beforeDestroy() {
    this.$eventHub.$off("toggle-sidebar", this.handleToggleSidebar)
  },
  methods: {
    handleToggleSidebar() {
      this.sidebarVisible = !this.sidebarVisible
    },
  },
}
</script>

<style lang="scss">
.main-sidebar {
  .item-icon-wrapper {
    display: inline-block;
  }

  .dropdown-menu {
    display: block;
  }
}
</style>
